export default __webpack_public_path__ + "static/media/ty.5ac8f440.jpg";